import React from "react"
import { componentStyles } from "@mallardbay/lib-react-components"

import ListingsMapMarker from "~components/pages/search/listings-map-marker"
import type {
    PublicSearchListingFieldsFragment,
    SearchListingFieldsFragment,
} from "~graphql/generated/graphql"
import Map from "~components/shared/map/map"
import Box from "~components/shared/todo-lib-react-components/box"

interface Props {
    readonly zoomControl?: boolean
    readonly listings?:
        | SearchListingFieldsFragment[]
        | PublicSearchListingFieldsFragment[]
}

export default function ListingsMap({
    zoomControl = true,
    listings = [],
}: Props) {
    const markers = listings.map(getListingLatLng)

    const styles = useStyles()

    function mapOptions() {
        return {
            zoomControl,
            scaleControl: false,
            draggable: true,
            fullscreenControl: true,
        }
    }

    return (
        <Box style={styles.container}>
            <Map options={mapOptions} markers={markers}>
                {listings.map((listing) => (
                    <ListingsMapMarker
                        key={listing.id}
                        listing={listing}
                        // lat/lng props are required by google-map-react to place markers
                        {...getListingLatLng(listing)}
                    />
                ))}
            </Map>
        </Box>
    )
}

function getListingLatLng(
    listing: PublicSearchListingFieldsFragment | SearchListingFieldsFragment
) {
    return {
        lat: listing.location?.lat ?? 0,
        lng: listing.location?.lng ?? 0,
    }
}

function useStyles() {
    return componentStyles({
        container: {
            position: "relative",
            width: "100%",
            height: "100%",
            overflow: "hidden",
        },
    })
}
